module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    ref: "header",
    staticClass: "header",
    class: [
      _vm.headerActive ? 'header--active' : null,
      _vm.showSearch ? 'header--search-active' : null,
      _vm.showMenu ? 'header--hamburger-active' : null ]
  }, [_c('div', {
    staticClass: "header__container-primary"
  }, [_c('a', {
    attrs: {
      "href": _vm.site.url
    }
  }, [_vm._t("brand-svg")], 2), _vm._v(" "), _c('nav', {
    staticClass: "header__navigation-container"
  }, [_c('div', {
    staticClass: "header__secondary-link-container"
  }, _vm._l((_vm.menus.header_secondary.items), function(item) {
    return _c('a', {
      staticClass: "paragraph-02 header__sublink",
      class: item.current ? 'header--current' : null,
      attrs: {
        "href": item.url
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "header__primary-link-container"
  }, [_vm._l((_vm.menus.header_primary.items), function(item) {
    return _c('a', {
      staticClass: "header__link",
      class: item.current ? 'header--current' : null,
      attrs: {
        "href": item.url
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })
  }), _vm._v(" "), _c('button', {
    staticClass: "header__search-svg-container",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleMenus('showSearch')
      }
    }
  }, [_vm._t("search-icon"), _vm._v(" "), (!_vm.showSearch) ? _c('span', {
    staticClass: "access-hidden",
    domProps: {
      "textContent": _vm._s('Search Button')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showSearch) ? _c('span', {
    staticClass: "access-hidden",
    domProps: {
      "textContent": _vm._s('Close Search')
    }
  }) : _c('span', {
    staticClass: "access-hidden",
    domProps: {
      "textContent": _vm._s('Open Search')
    }
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "header__hamburger-container",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleMenus('showMenu')
      }
    }
  }, [_c('span', {
    staticClass: "header__hamburger-bar-top"
  }), _vm._v(" "), _c('span', {
    staticClass: "header__hamburger-bar-middle"
  }), _vm._v(" "), _c('span', {
    staticClass: "header__hamburger-bar-bottom"
  }), _vm._v(" "), (_vm.showMenu) ? _c('span', {
    staticClass: "access-hidden",
    domProps: {
      "textContent": _vm._s('Close Menu')
    }
  }) : _c('span', {
    staticClass: "access-hidden",
    domProps: {
      "textContent": _vm._s('Open Menu')
    }
  })])], 2)])]), _vm._v(" "), (_vm.headerActive) ? _c('div', {
    staticClass: "header__container-secondary"
  }, [_c('a', {
    attrs: {
      "href": _vm.site.url
    }
  }, [_vm._t("brand-svg-horizontal")], 2), _vm._v(" "), _c('nav', {
    staticClass: "header__navigation-container"
  }, [_c('div', {
    staticClass: "header__primary-link-container"
  }, [_vm._l((_vm.menus.header_primary.items), function(item) {
    return _c('a', {
      staticClass: "header__link",
      class: item.current ? 'header--current' : null,
      attrs: {
        "href": item.url
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })
  }), _vm._v(" "), _c('button', {
    staticClass: "header__search-svg-container",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleMenus('showSearch')
      }
    }
  }, [_vm._t("search-icon-secondary"), _vm._v(" "), (!_vm.showSearch) ? _c('span', {
    staticClass: "access-hidden",
    domProps: {
      "textContent": _vm._s('Search Button')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showSearch) ? _c('span', {
    staticClass: "access-hidden",
    domProps: {
      "textContent": _vm._s('Close Search')
    }
  }) : _c('span', {
    staticClass: "access-hidden",
    domProps: {
      "textContent": _vm._s('Open Search')
    }
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "header__hamburger-container",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleMenus('showMenu')
      }
    }
  }, [_c('span', {
    staticClass: "header__hamburger-bar-top"
  }), _vm._v(" "), _c('span', {
    staticClass: "header__hamburger-bar-middle"
  }), _vm._v(" "), _c('span', {
    staticClass: "header__hamburger-bar-bottom"
  }), _vm._v(" "), (_vm.showMenu) ? _c('span', {
    staticClass: "access-hidden",
    domProps: {
      "textContent": _vm._s('Close Menu')
    }
  }) : _c('span', {
    staticClass: "access-hidden",
    domProps: {
      "textContent": _vm._s('Open Menu')
    }
  })])], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSearch),
      expression: "showSearch"
    }],
    staticClass: "header__modal"
  }, [_c('div', {
    staticClass: "header__modal-container"
  }, [_c('form', {
    staticClass: "header__modal-search-container",
    attrs: {
      "method": "get",
      "action": "/"
    }
  }, [_c('label', {
    staticClass: "access-hidden",
    attrs: {
      "for": "search"
    },
    domProps: {
      "textContent": _vm._s('Search')
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    staticClass: "header__modal-search-input",
    attrs: {
      "id": "search",
      "type": "search",
      "placeholder": "Search",
      "name": "search",
      "required": ""
    }
  })])])]), _vm._v(" "), (_vm.showMenu) ? _c('nav', {
    staticClass: "header__modal"
  }, [_c('div', {
    staticClass: "header__modal-menu-container"
  }, [_c('div', {
    staticClass: "header__modal-menu-inner"
  }, [_c('ul', {
    staticClass: "header__modal-list"
  }, _vm._l((_vm.menus.header_primary.items), function(item) {
    return (_vm.menus.header_primary.items) ? _c('li', {
      staticClass: "header__modal-item"
    }, [_c('a', {
      staticClass: "label-heading-01 header__modal-link",
      class: item.current ? 'header--current' : null,
      attrs: {
        "href": item.url
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })]) : _vm._e()
  }), 0), _vm._v(" "), _c('hr', {
    staticClass: "horizontal-rule-03"
  }), _vm._v(" "), _c('div', {
    staticClass: "header__modal-sublink-container"
  }, _vm._l((_vm.menus.header_secondary.items), function(item) {
    return _c('a', {
      staticClass: "paragraph-02 header__modal-sublink",
      class: item.current ? 'header--current' : null,
      attrs: {
        "href": item.url
      },
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })
  }), 0)])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49034f12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaseHeader.vue
// module id = 304
// module chunks = 1